// extracted by mini-css-extract-plugin
module.exports = {"container":"eventTabs_container__2jJRS"};